class ImgLoadListener {
    constructor(params) {
        this.params = params
        this.current = 0
        this.failTag = false
        this.imgs = document.querySelectorAll(params.node+' img')
        if (!this.imgs || this.imgs.length == 0) params.done()
        let self = this
        this.load_success = function (e) {
            if (++self.current == self.imgs.length) {
                params.done()
            }
        }
        this.load_fail = function (e) {
            console.log('fail')
            if (!this.failTag) {
                params.fail()
            }
            else {
                this.failTag = true
            }
        }

        for (let i = 0, len = this.imgs.length; i < len; i++) {
            let node = this.imgs[i]
            if (node.complete) {
                if (++self.current == self.imgs.length) {
                    params.done()
                    return
                }
                continue
            }
            console.log(node)
            node.onload = this.load_success
            node.onerror = this.load_fail
        }
    }

    reload() {
        this.current = 0
        this.failTag = false
        try {
            for(let i = 0, len = this.imgs.length; i < len; i++) {
                let img = this.imgs[i]
                img.src = img.src
            }
        }
        catch(e){
            this.params.fail()
        }
        
    }
}

export default ImgLoadListener